
import Vue from 'vue'
import { VDivider, VIcon, VMenu, VToolbar, VToolbarItems } from 'vuetify/lib'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import JcdcNavRouterLinkHref from '@/components/jcdc/JcdcNavRouterLinkHref.vue'
import JcdcNavRouterLinkRouter from '@/components/jcdc/JcdcNavRouterLinkRouter.vue'
import { filteredMenu, navList, userInfo } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouterDesktop',
  components: {
    VDivider,
    VIcon,
    VMenu,
    VToolbar,
    VToolbarItems,
    JcdcBtn,
    JcdcNavRouterLinkHref,
    JcdcNavRouterLinkRouter,
  },
  props: {
    navList: { type: Array as () => navList[], required: true },
    menuLevel: { type: Number, default: 0 },
    userInfo: { type: Object as () => userInfo, required: true },
    routeTest: { type: Array as () => string[], default: (): [] => [] }, // For Testing
  },
  data() {
    return {
      testOpen: false,
      storybook: process.env.NODE_ENV == 'storybook',
    }
  },
  methods: {
    filteredMenu,
    showChildrenInNav(item) {
      return (
        !!item.children &&
        item.meta?.childrenInNav != false &&
        item.meta?.navGroup != true
      )
    },
    isActive(item) {
      if ('path' in item) {
        let pathArray
        if (!this.storybook) pathArray = this.$route.path.split('/')
        else if (this.storybook && this.routeTest.length != 0) {
          pathArray = this.routeTest
        } else pathArray = []
        return pathArray.includes(item.path)
      }
      return false
    },
  },
})
